var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-content relative",
      class: { "no-chrome": !_vm.Ichrome },
      attrs: { id: "ap-library" },
    },
    [
      _vm.Ichrome
        ? _c("Titlebar", { attrs: { incrustation: "beepiz-aplibrary" } }, [
            _c("h1", [_vm._v(_vm._s(_vm.$t("ap.titles.library")))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          !_vm.editMode
            ? _c(
                "div",
                { class: _vm.libraryClasses },
                [
                  _c("UiCard", [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.Ichrome,
                              expression: "!Ichrome",
                            },
                          ],
                          staticClass: "col",
                        },
                        [
                          _c(
                            "h2",
                            { staticClass: "text-xl font-semibold m-0" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("ap.titles.librarylist")) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col flex gap-2" },
                        [
                          _c("FilterField", {
                            staticClass: "with-type-filters flex-1",
                            on: { filter: _vm.handleFilter },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "type-filters" },
                            _vm._l(_vm.icons, function (apType, key) {
                              return _c("i", {
                                key: key,
                                class: [apType, { disabled: !_vm.filter[key] }],
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleTypeFilter(key)
                                  },
                                },
                              })
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.isLoading
                      ? _c(
                          "div",
                          { staticClass: "py-5 flex justify-center" },
                          [_c("UiSpinner")],
                          1
                        )
                      : _vm.actionpoints.length == 0
                      ? _c("div", { staticClass: "py-5 center text-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.no_results")) +
                              "\n          "
                          ),
                        ])
                      : _c(
                          "div",
                          [
                            _c("APList", {
                              ref: "aplist",
                              attrs: {
                                list: _vm.actionpoints,
                                multiselect: !_vm.Ichrome && _vm.multiselect,
                                chrome: _vm.chrome,
                              },
                              on: {
                                apSelect: _vm.handleSelect,
                                apUnselect: _vm.handleUnselect,
                                next: _vm.handleNextPage,
                              },
                            }),
                          ],
                          1
                        ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col center" },
                        [
                          _c("UiPagination", {
                            ref: "pagination",
                            on: { change: _vm.handlePagination },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-action-point-can:create")
            ? _c(
                "div",
                { staticClass: "col" },
                [
                  _c("LoadingMini", { ref: "loading" }),
                  _vm._v(" "),
                  _c(
                    "UiCard",
                    [
                      _c("APForm", {
                        ref: "apForm",
                        on: { saved: _vm.handleSave, error: _vm.onError },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.Ichrome
                    ? _c(
                        "Toolbar",
                        {
                          staticClass: "mt-3 justify-content-end sticky top-2",
                        },
                        [
                          _vm.useDvFlagAccess("beepiz-action-point-can:delete")
                            ? _c(
                                "Btn",
                                {
                                  directives: [
                                    {
                                      name: "can",
                                      rawName: "v-can",
                                      value: "beepiz-delete-library",
                                      expression: "'beepiz-delete-library'",
                                    },
                                  ],
                                  staticClass: "default",
                                  class: { disabled: !_vm.isDeletable },
                                  attrs: { disabled: !_vm.isDeletable },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.deleteAP($event)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("global.delete"))),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.useDvFlagAccess("beepiz-action-point-can:create")
                            ? _c(
                                "Btn",
                                {
                                  directives: [
                                    {
                                      name: "can",
                                      rawName: "v-can",
                                      value: _vm.canBtnSave,
                                      expression: "canBtnSave",
                                    },
                                  ],
                                  staticClass: "primary",
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.validForm($event)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(_vm.labelBtnSave))])]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar-ghost" }),
      _vm._v(" "),
      !_vm.Ichrome
        ? _c(
            "Toolbar",
            {
              staticClass:
                "fixed bottom left right z-10 p-3 px-4 justify-content-end bg-white border-top",
            },
            [
              _c(
                "Btn",
                {
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.cancelAP($event)
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("global.cancel")))])]
              ),
              _vm._v(" "),
              _c(
                "Btn",
                {
                  staticClass: "primary",
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.validFormOrSelect($event)
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.labelButton))])]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }